import { WORKSHEET_CLASSES } from '../../constants/classNames';
import { getSiteEngine } from '../../data/sitePages';

const NOTEBOOK_FIELDS = Object.freeze([
  'I mixed',
  'My prediction (before pressing Mix)',
  'What happened',
  'Why it happened, in my own words',
  'Safety note',
]);

/**
 * Blank lab notebook entries. Every child picks their own experiments, so there is no answer key.
 */
export default function LabNotebookSheet({ worksheet }) {
  const engine = getSiteEngine();
  const ideas = worksheet.suggestedPairs
    .map((pair) => pair.map((id) => engine.getSubstance(id).name).join(' + '))
    .join(' · ');

  return (
    <>
      {Array.from({ length: worksheet.entryCount }, (_, index) => (
        <section key={index} className={WORKSHEET_CLASSES.entry}>
          <h2 className={WORKSHEET_CLASSES.partTitle}>Experiment {index + 1}</h2>
          {NOTEBOOK_FIELDS.map((label) => (
            <div key={label} className={WORKSHEET_CLASSES.field}>
              <span className={WORKSHEET_CLASSES.fieldLabel}>{label}:</span>
              <span className={WORKSHEET_CLASSES.blankWide} />
            </div>
          ))}
        </section>
      ))}
      <p className={WORKSHEET_CLASSES.footnote}>Need ideas? Try {ideas}.</p>
    </>
  );
}
